import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NoHistoryComponent } from './no-history.component';
import { SharedModule } from 'app/shared/shared.module';



@NgModule({
  declarations: [
    NoHistoryComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    NoHistoryComponent
  ]
})
export class NoHistoryModule { }
